import React, { useState, useEffect } from 'react'
import { message } from 'antd'
import PurchasesTable from './PurchasesTable'
import PurchasesDrawer from './PurchasesDrawer'
import InventoryTabsHeader from '../InventoryTabsHeader'
import InventoryTabsContent from '../InventoryTabsContent'
import inventorySrc from '../../inventorySrc'

function PurchasesTab(props) {
  const [showDrawer, setShowDrawer] = useState(false)
  const [editPurchase, setEditPurchase] = useState({})
  const [loading, setLoading] = useState(false)
  const [fetchData, setFetchData] = useState(true)

  useEffect(() => {
    if (showDrawer === false) setEditPurchase({})
  }, [showDrawer])
  const [searchText, setSearchText] = useState('')

  const onSearch = searchText => {
    setSearchText(searchText)
  }

  const onEditPurchase = id => {
    setLoading(true)
    inventorySrc
      .getPurchase(id)
      .then(purchase => {
        setEditPurchase(purchase)
        setShowDrawer(true)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la compra.')
        setLoading(false)
      })
  }

  const saveNewPurchase = data => {
    setFetchData(false)
    setLoading(true)
    inventorySrc
      .savePurchase(data)
      .then(res => {
        if (res.errors && Object.keys(res.errors)?.length > 0) {
          checkErrors(res)
          setLoading(false)
        } else {
          message.success('Información creada.')
          setShowDrawer(false)
          setLoading(false)
          setFetchData(true)
        }
      })
      .catch(err => {
        console.log(err)
        message.error('Error al guardar la compra')
        setLoading(false)
      })
  }

  const editPurchaseData = data => {
    setFetchData(false)
    setLoading(true)
    inventorySrc
      .editPurchase(data[0], data[1])
      .then(res => {
        if (res.errors && Object.keys(res.errors)?.length > 0) {
          checkErrors(res)
          setLoading(false)
        } else {
          message.success('Información actualizada.')
          setShowDrawer(false)
          setLoading(false)
          setFetchData(true)
        }
      })
      .catch(err => {
        console.log(err)
        message.error('Error al editar la compra')
        setLoading(false)
      })
  }

  const checkErrors = res => {
    let showDuplicateError = true

    const errors = Object.keys(res.errors).reduce((r, k) => {
      if (res.errors[k][0].indexOf('presentations') > -1 && res.errors[k][0].indexOf('duplicado') > -1) {
        showDuplicateError && message.error('No se admiten productos duplicados.')
        showDuplicateError = false
        return r
      } else {
        return Object.assign(r, { [k]: res.errors[k] })
      }
    }, {})

    Object.keys(errors).map(key => {
      switch (key) {
        case 'invoice':
          message.error(errors[key][0].replace('invoice', 'No. Factura'))
          break
        case 'serial_number':
          message.error(errors[key][0].replace('serial_number', 'No. Serie'))
          break
        default:
          message.error(errors[key])
          break
      }
      return null
    })
  }

  return (
    <div>
      <InventoryTabsHeader
        shopsList={props.shopsList}
        selectedOption={props.selectedOption}
        setSelectedOption={option => {
          props.setSelectedOption(option)
        }}
        onSearch={onSearch}
        buttonHandler={() => {
          setShowDrawer(true)
        }}
        buttonLabel={'Nueva compra'}
        createPermissions={26}
        keyTab={props.keyTab}
      />
      <InventoryTabsContent
        fetchData={fetchData}
        loading={loading}
        onEdit={onEditPurchase}
        component={PurchasesTable}
        selectedOption={props.selectedOption}
        searchText={searchText}
        keyTab={props.keyTab}
      />
      <PurchasesDrawer
        shopsList={props.shopsList}
        closable={(data, request) => {
          if (request === 'save') return saveNewPurchase(data)
          if (request === 'edit') return editPurchaseData(data)
          setShowDrawer(false)
        }}
        loading={loading}
        visible={showDrawer}
        edit={editPurchase}
      />
    </div>
  )
}

export default PurchasesTab

PurchasesTab.defaultProps = {
  selectedOption: null,
  shopsList: [],
}
